import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ReactSortable } from "react-sortablejs";
import { snapshotToArray } from '../../helpers';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeleteDepartment from '../DeleteDepartment';
import { useSelector } from 'react-redux';

const CatItem = (props) => {

    const activities = useSelector(state => state.activities);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = function (event) {
        event.preventDefault();
        setShow(true);
    };

    return (
        <React.Fragment>
            <div key={props.item.id} className="drag-item">{props.item.name}
                {activities.filter(activity => activity.category === props.item.slug).length === 0 ?
                    <a onClick={handleShow} href="#" className="delete-dept">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </a>
                    : ''}
            </div>
            <DeleteDepartment show={show} onHide={handleClose} item={props.item} category={true} department={props.department} deleteFromList={props.deleteFromList} />
        </React.Fragment>

    );
}

export default CatItem;
